

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const UPDATEUSUBDEPARTMENT= createAsyncThunk(
  "updateSubDepartment/updateSubDepartment",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const updateSubDepartmentSlice = createSlice({
  name: "updateSubDepartmentSlice",
  initialState: {
    updateSubDepartment: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfupdateSubDepartment: (state) => {
        state.updateSubDepartment.loading = false
        state.updateSubDepartment.error = false
        state.updateSubDepartment.data = []
        state.updateSubDepartment.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(UPDATEUSUBDEPARTMENT.fulfilled, (state, action) => {
      state.updateSubDepartment = {
        ...state.updateSubDepartment,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(UPDATEUSUBDEPARTMENT.pending, (state, action) => {
      state.updateSubDepartment = {
        ...state.updateSubDepartment,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(UPDATEUSUBDEPARTMENT.rejected, (state, action) => {
      state.updateSubDepartment = {
        ...state.updateSubDepartment,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const updateSubDepartmentAction = {
    UPDATEUSUBDEPARTMENT,
};

export { updateSubDepartmentAction };
export default updateSubDepartmentSlice.reducer;
export const {setInitialStateOfupdateSubDepartment} = updateSubDepartmentSlice.actions
